module.exports = __webpack_public_path__ + "videos/legacy_tab.0de0f1b.mp4";